import { createFileRoute, notFound } from '@tanstack/react-router';
import { ensureCatalogEntries } from '@/features/catalog/queries';
import { findProviderProfile } from '@/features/catalog/providerProfiles';
import { ProviderProfilePage } from '../../../pages/providers/ProviderProfilePage';

const ORIGIN = 'https://getanyapi.com';

export const Route = createFileRoute('/_site/providers/$providerId')({
  staticData: { footer: 'slim' },
  loader: async ({ context, params }) => {
    const profile = findProviderProfile(
      await ensureCatalogEntries(context.queryClient),
      params.providerId,
    );
    if (!profile) throw notFound();
    return profile;
  },
  head: ({ params, loaderData }) => {
    const canonical = `${ORIGIN}/providers/${params.providerId}`;
    const title = loaderData ? `${loaderData.source.name} Provider Traffic - AnyAPI` : 'Provider - AnyAPI';
    const description = loaderData
      ? `See the endpoints and successful 30-day traffic served by ${loaderData.source.name}.`
      : 'Browse provider traffic on AnyAPI.';
    return {
      meta: [
        { title },
        // Most provider profiles carry an anonymous animal `source` rather than
        // a routing provider slug, so they are near-identical thin pages that
        // exist to satisfy provider anonymity, not to rank. They are already
        // excluded from the sitemap; keep them crawlable (so the noindex is
        // seen) but out of the index. `follow` preserves their outbound links.
        { name: 'robots', content: 'noindex, follow' },
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: canonical },
      ],
      links: [{ rel: 'canonical', href: canonical }],
    };
  },
  component: ProviderProfileRoute,
});

function ProviderProfileRoute() {
  const { providerId } = Route.useParams();
  return <ProviderProfilePage providerId={providerId} initialProfile={Route.useLoaderData()} />;
}
